import React, { useEffect, useState } from 'react';
import JoinLiveLecture from '../components/video-components/JoinLiveLecture';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from '../backendService';
import { Spin } from 'antd';

const VideoLive = () => {
  const { roomKey } = useParams();
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const userId = Cookies.get('userId');
        const response = await axios.get(`users/getUserCourseData/${userId}`);
        console.log('USER DATAAAAAAA', response.data.user);
        setId(response.data.user._id);
        setName(response.data.user.userName);
        setEmail(response.data.user.email);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading && (!id || !name || !email) ? (
        <div className="w-full h-screen flex item-center justify-center">
          <div className="mt-[20vh]">
            <Spin size="large" />
          </div>
        </div>
      ) : (
        id && name && email && <JoinLiveLecture roomName={roomKey} id={id} name={name} email={email} />
      )}
    </>
  );
};

export default VideoLive;
